import VideoPlayerModal from "../../../../ui/modals/VideoPlayerModal";
import React from "react";
import {NotScoredVideoItem, ScoredVideoItem} from "../../../../ui/video_player/VideoItem";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import '../../../../../assets/sass/pages/full-profile/tabs/modals/videos-per-match-modal.scss';

class VideosPerMatchModal extends VideoPlayerModal {

    constructor(props) {
        super(props);
        this.state = {
            selectedVideo: null,
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        const {selected} = nextProps;

        this.setState({
            selectedVideo: selected
        });
    }

    renderHeader = () => undefined;

    /**
     * Renders the components within the body of the modal.
     * @returns {React.ReactNode} The body of the modal.
     */
    renderBody = () => {
        return (
            <div className="video-per-match-modal">
                {this.renderVideoPlayer()}
                {this.renderVideosList()}
            </div>
        );
    };

    /**
     * Wrap video items within carousel.
     * @returns {React.ReactNode} The wrapped items.
     */
    wrapItemsWithList = (items) => {
        const responsive = {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: {max: 4000, min: 3000},
                items: 8,
            },
            desktop: {
                breakpoint: {max: 3000, min: 1024},
                items: 8,
            },
            tablet: {
                breakpoint: {max: 1024, min: 464},
                items: 4,
            },
            mobile: {
                breakpoint: {max: 464, min: 0},
                items: 2,
            },
        };

        return (
            <Carousel
                arrows={false}
                swipeable={false}
                draggable={true}
                showDots={false}
                keyBoardControl={true}
                responsive={responsive}>
                {items}
            </Carousel>
        );
    };

    renderVideosList = () => {
        const {videos} = this.props;
        const {selectedVideo} = this.state;
        const items = videos.map((videoData, index) => {
            const {title, link, thumbnail, duration, dataField} = videoData;
            const active = selectedVideo === dataField;

            return (
                <VideosPerMatchModal.VideoItem
                    key={index}
                    active={active}
                    title={title}
                    link={link}
                    thumbnail={thumbnail}
                    duration={duration}
                    onClick={(event) => this.handleVideoSelect(event, dataField)}/>
            );
        });

        return (
            <div className="list">
                {this.wrapItemsWithList(items)}
            </div>
        );
    };


    getVideoSource = () => {
        const selectedVideo = this.getSelectedVideo();

        if (selectedVideo)
            return selectedVideo.link;
        return null;
    };


    getSelectedVideo = () => {
        const {videos} = this.props;
        const {selectedVideo} = this.state;

        const result = videos.filter((video) => video.dataField === selectedVideo);
        if (result.length === 0) return null;
        return result[0];
    };


    handleVideoSelect = (event, columnName) => {
        this.setState({
            ...this.state,
            selectedVideo: columnName,
        });
    };
}

VideosPerMatchModal.VideoItem = ScoredVideoItem;
VideosPerMatchModal.NotScoredVideoItem = NotScoredVideoItem;
VideosPerMatchModal.Name = 'VideosPerMatchModal';

export default VideosPerMatchModal;
